import { useLocation, Link } from "react-router-dom";
import "./Auth.css";

const CONTENT = {
  "/privacy": {
    title: "Privacy Policy",
    body: [
      "Rasaan Hakiem LLC (\"we\", \"us\") operates Liturgical Intelligence™ and its applications, including Parish Profile Intelligence™ and SundayBuilder™. This policy explains what we collect and how we use it.",
      "Information we collect: account details (name, email, organization), authentication data, the parish information you submit for assessments, and billing details processed securely by Stripe. We do not store full payment card numbers.",
      "How we use it: to provide and improve the service, generate your reports via Ordo AI™, manage your subscription and entitlements, and communicate with you about your account.",
      "Data sharing: we share data only with the processors required to run the service (e.g. Stripe for payments, our AI provider for report generation) and never sell your data.",
      "Your choices: you may update your profile or request deletion of your account at any time by contacting us.",
    ],
  },
  "/terms": {
    title: "Terms of Service",
    body: [
      "By creating an account you agree to these terms. Liturgical Intelligence™ is provided by Rasaan Hakiem LLC.",
      "Accounts & entitlements: each new verified account receives one complimentary Parish Intelligence Assessment. Additional reports require a Single Report purchase or an active subscription (Parish Pro, Cathedral, or Diocese).",
      "Acceptable use: you agree not to misuse the service, attempt to bypass entitlement limits, or use the AI outputs unlawfully. Reports are advisory and should be reviewed by qualified leadership.",
      "Billing: subscriptions renew automatically until cancelled via the customer portal. One-time purchases are non-recurring. All prices are shown before checkout.",
      "Liability: the service is provided \"as is\". To the extent permitted by law, Rasaan Hakiem LLC is not liable for indirect or consequential damages.",
    ],
  },
  "/cookies": {
    title: "Cookie Policy",
    body: [
      "We use cookies that are essential to operate Liturgical Intelligence™.",
      "Authentication cookie: a secure, httpOnly session cookie keeps you signed in. It is required for the service to function.",
      "Analytics: we may use privacy-respecting analytics to understand product usage and improve the experience.",
      "Managing cookies: you can clear cookies in your browser settings, but doing so will sign you out and may limit functionality.",
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const page = CONTENT[pathname] || CONTENT["/privacy"];
  return (
    <div className="legal-page" data-testid="legal-page">
      <div className="legal-bar">
        <Link to="/" className="legal-brand">Liturgical <span>Intelligence™</span></Link>
        <Link to="/login" className="legal-back" data-testid="legal-back">← Sign in</Link>
      </div>
      <div className="legal-body">
        <div className="legal-eyebrow">Legal</div>
        <h1>{page.title}</h1>
        <p className="legal-updated">Last updated: June 2026</p>
        {page.body.map((p, i) => <p className="legal-p" key={i}>{p}</p>)}
        <div className="legal-note">
          This is a general template provided for transparency. Please review with qualified counsel before relying on it for compliance.
        </div>
        <div className="legal-links">
          <Link to="/privacy">Privacy Policy</Link><span>·</span>
          <Link to="/terms">Terms of Service</Link><span>·</span>
          <Link to="/cookies">Cookie Policy</Link>
        </div>
      </div>
    </div>
  );
}
